<template>
  <v-card class="card-image" flat>
    <img class="d-block card-image-img" :src="url" />

    <div class="d-flex align-end px-3 px-sm-4 pb-3 card-image-caption">
      <div class="white--text text-body-2 font-weight-medium">
        {{ name }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    name: String,
    url: String,
  },
};
</script>

<style lang="scss" scoped>
$transition: all 0.1s linear;

.card-image {
  background-color: #ffffff;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0 0 0 / 0.1) !important;
  overflow: hidden;
  transition: $transition;

  @media screen and (max-width: 599.9px) {
    border-radius: 6px !important;
  }

  &-img {
    aspect-ratio: 4 / 3;
    object-fit: cover;
    transition: $transition;
    width: 100%;
  }

  &-caption {
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 25%,
      rgba(0, 0, 0, 0.2) 45%,
      rgba(0, 0, 0, 0.4) 65%,
      rgba(0, 0, 0, 0.7) 85%,
      rgba(0, 0, 0, 1) 100%
    );
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: $transition;
    width: 100%;
  }

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;

    .card-image-img {
      transform: scale(1.1);
    }

    .card-image-caption {
      opacity: 1;
    }
  }
}
</style>
